// Decides whether the one-time, dismissible install hint should appear.
// Pull, not push: only for an engaged mobile-browser visitor who hasn't
// dismissed it — never inside the native app or an installed PWA. See plans/M3.
import type { AppContext, InstallTarget } from "./app-context.js";

export interface HintInput {
  context: AppContext;
  target: InstallTarget;
  /** The visitor already showed intent (saved a home zone or enabled alerts). */
  engaged: boolean;
  /** They dismissed the hint before (persisted in settings). */
  dismissed: boolean;
}

export function shouldShowInstallHint(i: HintInput): boolean {
  if (i.context !== "browser") return false;
  if (i.target !== "ios-safari" && i.target !== "android-chrome") return false;
  if (i.dismissed) return false;
  return i.engaged;
}
